<div class="stackholder-chart-wrapper">
  <div *ngIf="loading" class="chart-state" aria-live="polite" aria-busy="true">
    <div class="spinner"></div>
    <div class="loader-text">Loading chart...</div>
  </div>

  <div *ngIf="!loading && chartData.length === 0" class="no-data">
    No data available.
  </div>

  <!-- Tooltip — rendered by Angular so it is never affected by SVG stacking -->
  <div *ngIf="tooltipVisible" class="stack-chart-tooltip">
    <div class="sct-month">{{ tooltipMonth }}</div>
    <div *ngFor="let item of tooltipItems"
         class="sct-row"
         [class.sct-row--current]="item.isCurrent">
      <span class="sct-swatch" [style.background]="item.color"></span>
      <span class="sct-key">{{ item.key }}</span>
      <span class="sct-val">{{ item.value }}</span>
    </div>
  </div>

  <!-- Chart canvas — always in DOM so ViewChild reference is available -->
  <div #stackChartContainer class="stack-chart-canvas"></div>

  <!-- Legend — below the chart, centre-aligned -->
  <div *ngIf="!loading && legendItems.length > 0" class="stack-legend">
    <div *ngFor="let item of legendItems" class="stack-legend-item">
      <span class="stack-legend-swatch" [style.background]="item.backgroundColor"></span>
      <span class="stack-legend-label">{{ item.key }}</span>
    </div>
  </div>
</div>
